import { render, staticRenderFns } from "./WorkerTypeView.vue?vue&type=template&id=5c53f1da&scoped=true&"
import script from "./WorkerTypeView.vue?vue&type=script&lang=js&"
export * from "./WorkerTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53f1da",
  null
  
)

export default component.exports